/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [edit-post-button.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 12.02.20, 12:03
 */

import React from 'react';
import MediaRichEditor from "../../media-rich-editor/media-rich-editor";
import {BUBBLE_CLOSE_BUTTON_ID} from "../../../actions";
import {useLanguage} from "../../configuration/configuration";
import {useAuthorization} from "../../../selectors";
import DialogBox from "../dialog-box";
import MediaImageEditor from "../../media-rich-editor/MediaImageEditor";

const EditPostDialog = ({post, setOpen, callback}) => {
    const {principalUsername} = useAuthorization();
    const Lang = useLanguage();

    const closeOnBubbledEvent = (event) => {
        if (event.target.id === BUBBLE_CLOSE_BUTTON_ID) {
            event.preventDefault();
            event.stopPropagation();
            setOpen(false);
        }
    };

    return <div className="edit-post-button" onClick={closeOnBubbledEvent}>
        <DialogBox cancelButton={false}
                   action={Lang.dialog.editPost.done}
                   isOpen={true}
                   setIsOpen={() => setOpen(false)}
                   title={Lang.dialog.editPost.title}
                   callback={() => setOpen(false)}>

            <div className='edit-post-dialog mt-3'>
                <MediaRichEditor id={`post-${post.id}`}
                                 text={post.text}
                                 username={principalUsername}
                                 callback={callback}
                                 setIsOpen={setOpen}/>
            </div>
            <div>
                <MediaImageEditor username={principalUsername} post={post}/>
            </div>
        </DialogBox>

    </div>
}

export default EditPostDialog;